<template>
  <div class="selectGrop pointer">
    <div class="top">
      <NavBar title="选择分组"></NavBar>
    </div>
    <div class="content">
      <div class="contentBox">
        <div class="card" v-for="item in cardList" :key="item.id">
          <div class="cardLeft">
            <div class="leftName">{{ item.groupName }}</div>
            <div class="leftNum">共{{ item.instanceList.length }}台</div>
          </div>
          <button class="cardRight button" @click="movement(item.id)">
            移入分组
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import { groupInstance } from "@/api/instance";
import { groupList } from "@/api/index";
export default {
  name: "selectGrop",
  components: {
    NavBar,
  },
  data() {
    return {
      results: [],
      cardList: [],
    };
  },
  mounted() {
    this.results = this.$route.params.results;
    this.getGroupList();
  },
  methods: {
    // 获取分组信息
    getGroupList() {
      groupList().then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].showStatus = false;
          }
          let arr = res.data;
          for (let i = 0; i < arr.length; i++) {
            for (let k = 0; k < arr[i].instanceList.length; k++) {
              if (arr[i].instanceList[k].overSoldDevice) {
                arr[i].instanceList.splice(k, 1);
              }
            }
          }
          this.cardList = arr;
        } else {
          Toast(res.msg);
        }
      });
    },
    movement(id) {
      let data = {
        id: id,
        deviceIds: this.results,
      };
      groupInstance(data).then((res) => {
        if (res.code == 200) {
          this.$router.go(-1);
        } else {
          Toast(res.msg);
        }
      });
    },
  },
};
</script>
      
  <style lang="less" scoped>
.button {
  border: none;
  background: none;
}
.top {
  height: 44px;
}
.content {
  box-sizing: border-box;
  padding: 0 12px;
  .contentBox {
    .card {
      width: 351px;
      height: 74px;
      background: #fff;
      border-radius: 10px;
      margin-top: 10px;
      box-sizing: border-box;
      padding: 13px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .cardLeft {
        text-align: left;
        .leftName {
          font-size: 17px;
          font-weight: 500;
          color: #333;
          margin-bottom: 4px;
        }
        .leftNum {
          font-size: 13px;
          font-weight: 400;
          color: #999;
        }
      }
      .cardRight {
        width: 90px;
        height: 36px;
        border-radius: 18px;
        border: 1px solid #89afff;
        font-size: 15px;
        font-weight: 400;
        color: #0066ff;
      }
    }
  }
}
</style>